import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import Overlay from "../Overlay/Overlay";
import NavPagination from "./NavPagination";
import PagingInfo from "./PagingInfo";
import Search from "./Search";
import Filter from "./Filter";
import TableData from "./TableData";
import AddButton from "./AddButton";
import Modal from "../Layout/Modal";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";

const $ = window.$;
let timeoutId = 0;

const MTable = forwardRef((props, ref) => {
  const {
    defaultSort,
    columns,
    onAddData,
    showIndex,
    showCustomButton,
    showAddButton,
    orders,
    getData,
    hideFilter,
    filterChilds,
    customFilter,
    enableFilter,
    rowClick,
    rowSelector,
    checkbox,
    hideCheckbox = null,
    checked,
    checkAll,
    onChecked,
    disabledCheckbox,
    combineDirection = false,
    direction = "asc",
    showAllFunc = null,
    showAllState = null,
  } = props;

  const [state, setCurrentState] = useState({
    data: [],
    total: 0,
    filters: [],
    filter: { field: "", value: "", title: "" },
    search: "",
    processing: false,
    mTableId: `mTableId_${parseInt(Math.random() * 10000000)}`,
    filterChildId: `filterChildId_${parseInt(Math.random() * 10000000)}`,
  });
  const [paginator, setPaginator] = useState({
    page: 1,
    perpage: 10,
    search: "",
    filterOr: "",
    filterAnd: "",
    filter: "",
    orders: orders ? orders : defaultSort ? `${defaultSort}:asc` : "id:asc",
    direction: direction,
    refresh: false,
  });

  const setState = (value) => {
    setCurrentState({ ...state, ...value });
  };

  const mFilterRule = props.filterRule ? props.filterRule : "filterAnd";

  useEffect(() => {
    if (combineDirection === true) {
      if (paginator.orders.indexOf(":") == -1) {
        paginator.orders = paginator.orders + ":" + paginator.direction;
      }
      delete paginator.direction;
    }
    let loadTimeout = setTimeout(() => {
      setState({ processing: true });
    }, 150);
    let _paginator = null;
    const _customFilter = customFilter || "";
    if (mFilterRule == "filter") {
      _paginator = {
        ...paginator,
        [mFilterRule]: customFilter
          ? paginator[mFilterRule] + _customFilter
          : paginator[mFilterRule],
      };
    } else {
      _paginator = { ...paginator, filter: _customFilter };
    }
    if (!_paginator[mFilterRule]) {
      delete _paginator[mFilterRule];
    }
    delete _paginator.refresh;
    getData &&
      getData(_paginator)
        .then((res) => {
          clearTimeout(loadTimeout);
          const {
            data: { data, total },
          } = res;
          if (data.data)
            setState({ data: data.data, total, processing: false });
          else setState({ data, total, processing: false });
        })
        .catch((err) => {
          clearTimeout(loadTimeout);
          setState({ processing: false, data: [], total: 0 });
        })
        .finally((_) => $(mTableId).modal("hide"));
  }, [paginator, customFilter]);

  useImperativeHandle(ref, () => ({
    refresh: () => {
      setPaginator({ ...paginator, refresh: !paginator.refresh });
    },
  }));

  const onPerPageChange = (e) => {
    setPaginator({ ...paginator, perpage: e.value, page: 1 });
  };

  const onFirst = () => {
    setPaginator({ ...paginator, page: 1 });
  };

  const onLast = () => {
    setPaginator({ ...paginator, page: lastPage });
  };

  const onNext = () => {
    setPaginator({ ...paginator, page: paginator.page + 1 });
  };

  const onPrev = () => {
    setPaginator({ ...paginator, page: paginator.page - 1 });
  };

  const onSort = (field) => () => {
    const direction = paginator.direction == "asc" ? "desc" : "asc";
    if (combineDirection === true)
      setPaginator({ ...paginator, orders: `${field}:${direction}` });
    else
      setPaginator({
        ...paginator,
        orders: `${field}:${direction}`,
        direction,
      });
  };

  const onSearchChange = (e) => {
    const value = e.target.value;
    setState({ search: value });
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      setPaginator({ ...paginator, search: value, page: 1 });
    }, 500);
  };

  const onClear = () => {
    setState({ search: "" });
    setPaginator({ ...paginator, search: "" });
  };

  const openFilter = () => {
    $(`#${mTableId}_filter`).animate(
      {
        height: 400,
        opacity: 1,
      },
      150
    );
  };

  const closeFilter = () => {
    $(`#${mTableId}_filter`).animate(
      {
        height: 0,
        opacity: 0,
      },
      150
    );
  };

  const onAddFilter = () => {
    if (filter.field && filter.value) {
      if (typeof filter.value != "boolean") {
        filter.value = filter.value.trim();
      }

      const _filters = [...filters, filter];
      setState({
        filters: _filters,
        filter: { field: "", value: "", title: "" },
      });

      const _filter = _filters.map((e) => `${e.field}:${e.value}`).join();
      setPaginator({ ...paginator, page: 1, [mFilterRule]: _filter });
    }
  };

  const onValueEnter = (e) => {
    if (e.key == "Enter") {
      onAddFilter();
    }
  };

  const onRemoveFilter = (item) => () => {
    const _filters = filters.filter((e) => e.field != item.field);
    setState({ filters: _filters });

    const _filter = _filters.map((e) => `${e.field}:${e.value}`).join();
    setPaginator({ ...paginator, [mFilterRule]: _filter });
  };

  const onFilterFieldChange = (e) => {
    const select = e.target;
    const title = select.options[select.selectedIndex].text;
    const _filter = { ...filter, field: select.value, title };
    setState({ filter: _filter });
  };

  const onFilterValueChange = (e) => {
    const _filter = { ...filter, value: e.target.value };
    setState({ filter: _filter });
  };

  const onResetFilter = () => {
    //console.log("Clear Fiilter");
    setState({ filters: [] });
    setPaginator({ ...paginator, [mFilterRule]: "" });
    closeFilter();
  };

  const onCloseFilterChild = () => {
    $(`#${filterChildId}`).modal("hide");
  };

  const onActionFilterChild = () => {
    filterChilds.action();
    $(`#${filterChildId}`).modal("hide");
  };

  const onAddDataClick = () => {
    if (onAddData) {
      onAddData();
    }
  };

  const {
    data,
    total,
    filters,
    filter,
    search,
    processing,
    mTableId,
    filterChildId,
  } = state;
  const totalPage = Math.ceil(total / paginator.perpage);
  const lastPage = totalPage;
  const startRow = (paginator.page - 1) * paginator.perpage + 1;
  const _endRow = paginator.page * paginator.perpage;
  const endRow = _endRow >= total ? total : _endRow;

  const tableProps = {
    showIndex,
    columns,
    data,
    paginator,
    startRow,
    onSort,
    rowClick,
    rowSelector,
    hideCheckbox,
    hideFilter,
    checkbox,
    checkAll,
    checked,
    onChecked,
    disabledCheckbox,
  };
  const filterProps = {
    mTableId,
    filter,
    filters,
    hideFilter,
    columns,
    openFilter,
    closeFilter,
    onAddFilter,
    onFilterFieldChange,
    onFilterValueChange,
    onRemoveFilter,
    onResetFilter,
    onValueEnter,
    customFilter,
    filterChilds,
    filterChildId,
  };
  const navPaginationProps = {
    paginator,
    lastPage,
    totalPage,
    onPrev,
    onNext,
    onFirst,
    onLast,
  };

  const darkMode = useSelector((state) => state.theme.darkMode);

  return (
    <div className="" id={mTableId}>
      <Overlay display={processing} />
      {data && (
        <div className="d-flex" style={{ columnGap: "20px" }}>
          <Search
            search={search}
            onClear={onClear}
            onSearchChange={onSearchChange}
          />
          {enableFilter && <Filter {...filterProps} />}
          {showAllFunc && showAllState !== null && (
            <div
              className="form-check"
              id={`all-active-check${darkMode ? "-dark" : ""}`}
            >
              <input
                className={`form-check-input ${
                  darkMode ? "customized-input-dark" : "customized-input"
                }`}
                type="checkbox"
                checked={showAllState}
                onChange={showAllFunc}
              />
              <label className="form-check-label">Show All</label>
            </div>
          )}
          {showCustomButton == true && (
            <div
              className="form-check"
              id={`all-active-check${darkMode ? "-dark" : ""}`}
            >
              <input
                className={`form-check-input ${
                  darkMode ? "customized-input-dark" : "customized-input"
                }`}
                type="checkbox"
                checked={showAllState}
                onChange={showAllFunc}
              />
              <label className="form-check-label">Show All</label>
            </div>
          )}

          {showAddButton && (
            <AddButton
              onAddDataClick={onAddDataClick}
              filterChilds={filterChilds}
            />
          )}
        </div>
      )}
      {/**Table data component, display data  */}
      {data && data.length > 0 && (
        <div>
          <TableData {...tableProps} />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#eeeeee",
              borderBottomLeftRadius: "12px",
              borderBottomRightRadius: "12px",
              marginTop: "-1rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              paddingTop: "0.5rem",
              paddingBottom: "0.5rem",
              alignItems: "center",
              color: "#757575",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "5px",
              }}
            >
              <div>
                <strong style={{ fontSize: "0.9rem" }}>Showing</strong>
              </div>
              <div style={{ fontSize: "0.9rem" }}>
                {`${endRow} of ${total} items`}
              </div>
              <div>|</div>
              <div>
                <strong style={{ fontSize: "0.9rem" }}>Rows Per Page</strong>
              </div>
              <div>
                <Dropdown
                  options={[5, 10, 25, 50, 100]}
                  value={paginator.perpage}
                  onChange={onPerPageChange}
                  className="paging-dropdown"
                />
              </div>
            </div>
            {/*<div
              style={{
                minWidth: 180,
                display: "flex",
                flexDirection: "column",
              }}
            >
             
            </div>*/}

            <div style={{ display: "flex", alignItems: "center" }}>
              <PagingInfo
                paginator={paginator}
                onPerPageChange={onPerPageChange}
                totalPage={totalPage}
              />
              {/**Paging navigation compoennt, render paging navigation button */}
              <NavPagination {...navPaginationProps} />
            </div>
          </div>
        </div>
      )}
      {data && data.length == 0 && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            height: "100%",
            fontSize: "1.2rem",
            color: "#757575",
            padding: "1rem 0",
            gap: "0.5rem",
          }}
        >
          <i className="fas fa-circle-info"></i>
          No Data Found
        </div>
      )}
      {/*<div className="mb-3 mt-3" style={{ height: 1, background: '#ccc' }} />*/}

      {/*<div style={{ padding: "0 0.2rem" }}>
        <div
          className="row"
          style={{
            backgroundColor: "#cccccc",
            padding: "0.2rem",
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          }}
        >
          <div className="col-lg-2 col-md-3 col-sm-12">
            <div
              className="mt-2"
              style={{ minWidth: 180, textAlign: "center" }}
            >
              <strong>SHOWING</strong>
              <br />
              <div
                style={{ margin: "0.15rem 0 0.45rem 0" }}
              >{`${startRow} - ${endRow} of ${total}`}</div>
            </div>
          </div>
          <div className="col-lg-10 col-md-9 col-sm-12">
            <div className="row justify-content-end">       
            </div>
          </div>
        </div>
      </div>*/}

      {filterChilds && (
        <Modal
          id={filterChildId}
          title="Advanced Filter"
          onClose={onCloseFilterChild}
          onAction={onActionFilterChild}
          btnActionName="Filter"
        >
          {filterChilds.view}
        </Modal>
      )}
    </div>
  );
});

export default MTable;
